import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const ImportTypeLocationStateSchema = z.object({
    importTypeCompLocStateXrefId: z.number().nullable().optional(),
    importTypeId: z.number(),
    compLocId: z.number(),
    stateId: z.string(),
    companyLocationName: z.string().nullable().optional(),
    beginDate: z.preprocess(
        (val) => (val ? new Date(val as string | Date) : null),
        z.date().nullable().optional()
    ),
    expired: z.boolean(),
});

export type ImportTypeLocationState = z.infer<typeof ImportTypeLocationStateSchema>;

export const all = async (
    pagination: PaginationState,
    sorting: SortingState = [],
    importTypeId: number,
    params: object,
): Promise<{ data: ImportTypeLocationState[]; total: number }> => {
    let queryString = '';
    if (params) {
        const paramsAsString = JSON.stringify(params)
            .replace(/:/g, '=')
            .replace(/,/g, '&')
            .replace(/[{}"]/g, '');

        const searchParams = new URLSearchParams(paramsAsString);
        if (pagination) {
            searchParams.append('pageSize', pagination.pageSize.toString());
            searchParams.append('pageIndex', pagination.pageIndex.toString());
        }

        if (sorting.length > 0) {
            searchParams.append('sortBy', sorting[0].id);
            searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
        }

        queryString = `?${searchParams.toString()}`;
    }

    const response = await fetch(
        `/admin/locationstate/${importTypeId}${queryString}`,
    );

    return await response.json();
};

export const add = async (locationState: ImportTypeLocationState): Promise<boolean> => {
    const res = await fetch(
        `/admin/locationstate/${locationState.importTypeId}`,
        {
            method: 'POST',
            body: JSON.stringify(locationState),
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
    return res.ok;
};

export const update = async (locationState: ImportTypeLocationState): Promise<boolean> => {
    const res = await fetch(`/admin/locationstate/${locationState.importTypeId}`, {
        method: 'PATCH',
        body: JSON.stringify(locationState),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return res.ok;
};
